import { useContext } from 'react';
import { WorkspaceContext } from '../contexts/WorkspaceContext';

export function useWorkspace() {
  return useContext(WorkspaceContext);
}
